<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <div class="wrap" ref="wrap">
      <div class="ScaleBox" ref="ScaleBox">
        <webHead></webHead>
        <router-view />
      </div>
    </div>
    <div class="footer" v-if="$route.path === '/generalization'">
     <div class="footer-content">
      <div class="d">版权所有: 汉中市经济合作局</div>
      <div class="d">主办单位: 汉中市经济合作局</div>
      <div class="d">地址: 汉中市汉台区民主街43号</div>
      <div class="d">咨询电话: 0916-2628906 邮编: 723000</div>
      <div class="d">服务传真: 0916-2628909 汉中网安: 61230001</div>
      <a class="d" href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank"
        >陕公网安备 61070202000003号</a
      >
      <a class="d" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
        >陕ICP备2023005988号-1</a
      >
     </div>
     <div class="footer-content">
      <div class="d">网站标识码:6107000015</div>
      <a class="d" href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=bm09000026&url=https%3A%2F%2Fbeian.mps.gov.cn%2F%23%2Fquery%2FwebSearch" target="_blank"
      > <img src="@/assets/zfzc.png" alt="" /></a
      >
      <a class="d" href="https://bszs.conac.cn/sitename?method=show&id=223521F9C45E0E5EE053022819ACAB07" target="_blank"
      ><img src="@/assets/dzjg.png" alt="" /></a
    >
      
     
     </div>
    </div>
  </div>
</template>
<script>
import webHead from "@/components/webHead.vue";
export default {
  name: "ScaleBox",
  data() {
    return {
      scale: null,
      width: 1536,
      height: 718,
      heightValue: 718,
      widthValue: 1536,
    };
  },
  components: {
    webHead,
  },
  mounted() {
    // console.log(this);
    this.setScale();
    window.addEventListener("resize", this.setScale);
  },
  methods: {
    getScale() {
      const { width, height } = this;
      // 原始写法
      // console.log('浏览器',window.innerWidth,window.innerHeight);
      // let ww = window.innerWidth / width;
      // let wh = window.innerHeight / height;
      // console.log(ww,"设备比1920");
      // return ww < wh ? wh : ww;
      // 修改的写法
      // console.log(document.documentElement.clientWidth,"设备");
      // console.log(document.documentElement.clientHeight,"设备1");
      let ww = document.documentElement.clientWidth / width;
      let wh = document.documentElement.clientHeight / height;
      // console.log("设备2",ww);
      // console.log("设备3",wh);
      return ww < wh ? ww : wh;
      // return ww
    },
    setScale() {
      this.scale = this.getScale();
      this.$refs.ScaleBox.style.setProperty("--scale", this.scale); //设置指定键值对系统属性
      this.$refs.wrap.style.setProperty(
        "--heightValue",
        this.scale * this.heightValue + "px"
        // this.scale * this.heightValue
      );
      this.$refs.wrap.style.setProperty(
        "--widthValue",
        this.scale * this.widthValue + "px"
      );
    },
  },
};
</script>
<style>
@import "@/utils/public.css";
</style>
<style lang="less" scoped>
#app {
  position: relative; /* 确保footer相对于app定位 */
  min-height: 100vh;
}

.footer {
  position: fixed;
  bottom:40px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 16px;
  line-height: 1.1;
  color: #fff;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  background: rgba(1, 23, 66, 0); /* 半透明背景匹配主色调 */
  z-index: 1000; /* 确保在最上层 */
  padding: 20px 0;
  .footer-content{
    display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  .d{
	margin: 0 20px;
}
  a {
    color: #4d8eff; /* 链接使用醒目颜色 */
    text-decoration: none;
    margin: 0 5px;
    &:hover {
      text-decoration: underline;
    }
  }
  }

}
#ScaleBox {
  --scale: 1;
}

.wrap {
  width: var(--widthValue);
  height: var(--heightValue);
  background-color: #011742;
  overflow: hidden;
}

.ScaleBox {
  width: 100%;
  height: 100%;
  transform: scale(var(--scale));
  transform-origin: 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
<style>
/*隐藏滚轮*/
::-webkit-scrollbar {
  display: none;
  width: 0 !important;
}

html,
body,
div {
  -ms-overflow-style: none;
}

html,
body,
div {
  overflow: -moz-hidden-unscrollable;
}
</style>
